import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function LeaderboardRows() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    async function load() {
      try {
        const res = await fetch('/smart-games/api/leaderboard/space-collect');
        const json = await res.json();
        setRows(json.leaderboard || []);
      } catch (_e) {
        setRows([]);
      }
    }
    load();
  }, []);
  if (!rows.length) {
    return (
      <tr>
        <td className="px-4 py-2 text-sm text-gray-500" colSpan={3}>No results yet.</td>
      </tr>
    );
  }
  return (
    <>
      {rows.map((r, idx) => (
        <tr key={idx}>
          <td className="px-4 py-2 text-sm text-gray-700">{r.rank}</td>
          <td className="px-4 py-2 text-sm text-gray-700">{r.player}</td>
          <td className="px-4 py-2 text-sm text-gray-900 text-right">{r.iqscore}</td>
        </tr>
      ))}
    </>
  );
}

function SmartGames() {
  return (
    <div className="bg-white">
      <style>{`
      @keyframes retroGradientShift { 0% {background-position:0% 50%} 50% {background-position:100% 50%} 100% {background-position:0% 50%} }
      .retro-title { background: linear-gradient(90deg, #ff00cc, #3333ff, #00e0ff, #00ff85, #ffdd00, #ff00cc); background-size: 400% 100%; -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; animation: retroGradientShift 8s ease infinite; text-shadow: 0 2px 20px rgba(0,0,0,0.08);} 
      `}</style>

      <section className="bg-gradient-to-b from-white to-gray-50 py-12" style={{ paddingTop: '200px' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="retro-title text-4xl sm:text-5xl font-extrabold tracking-tight">SMART GAMES</h1>
            <p className="mt-3 max-w-2xl mx-auto text-base text-gray-500">
              Cognitive mini-games built by AMHAS. Play now and climb the leaderboards.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-2">
            <div className="rounded-lg border border-gray-200 p-6 shadow-sm bg-white">
              <h3 className="text-xl font-semibold text-gray-900">Space Collect</h3>
              <p className="mt-2 text-sm text-gray-600">
                Navigate and collect while optimizing your score. Designed for quick cognitive checks.
              </p>
              
              <div className="mt-6">
                <h4 className="text-sm font-semibold text-gray-800 mb-3">Top 20 Leaderboard</h4>
                <div className="overflow-hidden rounded-md border border-gray-200">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rank</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Player</th>
                        <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">IQ Score</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      <LeaderboardRows />
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="mt-4">
                <Link
                  to="/smart-games/space-collect"
                  className="inline-flex items-center justify-center rounded-md bg-emerald-600 px-4 py-2 text-white font-medium hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                >
                  Play Space Collect
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SmartGames;


